import { BaseModel } from '@app/shared/models/base';
import { EmailSecurityOptions } from '@app/shared/models/credentials';

export class EmailProvider extends BaseModel {
    public host: string;
    public port: number;
    public security: EmailSecurityOptions;
    public provider?: string; // if the provider field is undefined then it's not sent to the BE

    constructor(json?: any) {
        super(json);
    }
}
